import(/* webpackMode: "eager" */ "/app/src/assets/styles/scss/index.scss");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@sbercloud+figma-tokens-admin@17.1.0/node_modules/@sbercloud/figma-tokens-admin/build/css/brand.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@sbercloud+figma-tokens-cloud-platform@17.7.2/node_modules/@sbercloud/figma-tokens-cloud-platform/build/css/brand.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@sbercloud+figma-tokens-mlspace@17.7.2/node_modules/@sbercloud/figma-tokens-mlspace/build/css/brand.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@sbercloud+figma-tokens-web@17.7.2/node_modules/@sbercloud/figma-tokens-web/build/css/brand.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["RootProvider"] */ "/app/src/context/Root.tsx");
